"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _initialDataMiddleware = require("./initialDataMiddleware");
Object.keys(_initialDataMiddleware).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _initialDataMiddleware[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _initialDataMiddleware[key];
        }
    });
}); //# sourceMappingURL=index.js.map
